// // src/components/AuthoringComponent/VendorAssemblyMapPage.tsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useVendorStore } from "../../store/vendorStore";
// import { useVendorAssemblyStore } from "../../store/vendorAssemblyStore";
// import { useUserStore } from "../../store/userStore";

// function rowKey(a: { finalAssemblyId: number }) { return a.finalAssemblyId; }
// function normRole(user: any): string {
//   const raw = typeof user?.role === "string" ? user.role : user?.role?.roleName;
//   return String(raw || "").trim().toUpperCase();
// }

// const pageWrap: React.CSSProperties = {
//   padding: "16px 20px 24px",
// };

// const headerRow: React.CSSProperties = {
//   display: "flex",
//   flexWrap: "wrap",
//   alignItems: "center",
//   justifyContent: "space-between",
//   gap: 12,
//   marginBottom: 12,
//   borderBottom: "1px dashed #e6e6e6",
//   paddingBottom: 8,
// };

// const titleWrap: React.CSSProperties = {
//   display: "flex",
//   alignItems: "center",
//   gap: 12,
// };

// const badge: React.CSSProperties = {
//   display: "inline-flex",
//   alignItems: "center",
//   gap: 4,
//   padding: "6px 10px",
//   borderRadius: 999,
//   border: "1px solid #e5e5e5",
//   background: "#f8f9fa",
//   fontSize: 12,
// };

// const controlsWrap: React.CSSProperties = {
//   display: "flex",
//   alignItems: "center",
//   gap: 8,
// };

// const grid: React.CSSProperties = {
//   display: "grid",
//   gap: 16,
//   gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))",
// };

// const panel: React.CSSProperties = {
//   border: "1px solid #eee",
//   borderRadius: 12,
//   boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
//   overflow: "hidden",
//   background: "#fff",
// };

// const panelHeader: React.CSSProperties = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   gap: 10,
//   padding: "10px 12px",
//   background: "#f7f7f7",
//   borderBottom: "1px solid #eee",
// };

// const headerTools: React.CSSProperties = {
//   display: "flex",
//   alignItems: "center",
//   gap: 8,
// };

// const panelBody: React.CSSProperties = {
//   padding: 0,
// };

// export default function VendorAssemblyMapPage() {
//   const { items: vendors, hasLoadedOnce: vLoaded, loading: vLoading, loadAll: loadVendors } = useVendorStore();
//   const { vendorId, map, loading, error, setVendor, load, assign, deactivate } = useVendorAssemblyStore();

//   const user = useUserStore((s) => s.user);
//   const role = normRole(user);
//   const userVendorId = Number(user?.vendorId ?? 0);

//   const [leftQ, setLeftQ] = useState("");
//   const [rightQ, setRightQ] = useState("");

//   useEffect(() => { if (!vLoaded) void loadVendors(); }, [vLoaded, loadVendors]);

//   // Optional auto-pick; selector stays visible regardless
//   useEffect(() => {
//     if (!vLoaded) return;
//     if (!vendorId) {
//       if (role === "VENDOR" && userVendorId > 0) setVendor(userVendorId);
//       else if (vendors.length === 1) setVendor(vendors[0].vendorId);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [vLoaded, vendorId, vendors.length, role, userVendorId]);

//   useEffect(() => { if (vendorId) void load(vendorId); }, [vendorId, load]);

//   const selectedVendor = useMemo(() => vendors.find(v => v.vendorId === vendorId), [vendors, vendorId]);

//   const available = useMemo(() => {
//     const arr = map?.available ?? [];
//     const term = leftQ.trim().toLowerCase();
//     if (!term) return arr;
//     return arr.filter(a =>
//       (a.componentPartNumber || "").toLowerCase().includes(term) ||
//       (a.componentDescription || "").toLowerCase().includes(term)
//     );
//   }, [map, leftQ]);

//   const assigned = useMemo(() => {
//     const arr = map?.assigned ?? [];
//     const term = rightQ.trim().toLowerCase();
//     if (!term) return arr;
//     return arr.filter(a =>
//       (a.componentPartNumber || "").toLowerCase().includes(term) ||
//       (a.componentDescription || "").toLowerCase().includes(term)
//     );
//   }, [map, rightQ]);

//   const canAct = Boolean(vendorId) && !loading;

//   return (
//     <div style={pageWrap}>
//       {/* Always-visible selector row */}
//       <div style={headerRow}>
//         <div style={titleWrap}>
//           <h5 style={{ margin: 0 }}>Vendor ↔ Models Mapping</h5>
//           <span style={badge}>
//             <span>Selected vendor:</span>
//             <strong>{selectedVendor?.vendorName ?? "—"}</strong>
//             {vendorId ? <span style={{ color: "#888" }}>#{vendorId}</span> : null}
//           </span>
//         </div>

//         <div style={controlsWrap}>
//           <select
//             className="form-select form-select-sm"
//             style={{ minWidth: 260 }}
//             value={vendorId ?? ""}
//             onChange={(e) => setVendor(e.target.value ? Number(e.target.value) : null)}
//             disabled={vLoading}
//           >
//             <option value="">Select Vendor…</option>
//             {vendors.map(v => (
//               <option key={v.vendorId} value={v.vendorId}>{v.vendorName}</option>
//             ))}
//           </select>
//           <button
//             className="btn btn-sm btn-outline-secondary"
//             onClick={() => vendorId && load(vendorId)}
//             disabled={!vendorId || loading}
//           >
//             {loading ? (
//               <>
//                 <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
//                 Loading…
//               </>
//             ) : (
//               "Refresh"
//             )}
//           </button>
//         </div>
//       </div>

//       {error && <div className="alert alert-danger">{error}</div>}

//       {/* Two panels — no container/grid classes, pure CSS grid */}
//       <div style={grid}>
//         {/* LEFT: Available */}
//         <div style={panel}>
//           <div style={panelHeader}>
//             <strong>Available models</strong>
//             <div style={headerTools}>
//               <input
//                 type="search"
//                 className="form-control form-control-sm"
//                 placeholder="Search…"
//                 value={leftQ}
//                 onChange={(e) => setLeftQ(e.target.value)}
//                 style={{ width: 240 }}
//               />
//               <button className="btn btn-sm btn-light" onClick={() => setLeftQ("")} disabled={!leftQ}>
//                 Clear
//               </button>
//             </div>
//           </div>

//           <div style={panelBody}>
//             <div className="table-responsive">
//               <table className="table table-hover table-sm mb-0">
//                 <thead className="table-light">
//                   <tr>
//                     <th style={{ width: 120 }}>Final ID</th>
//                     <th>Part # / Description</th>
//                     <th style={{ width: 110 }} className="text-end">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {!vendorId && (
//                     <tr>
//                       <td colSpan={3}>
//                         <div className="p-3 text-center text-muted">Select a vendor above to view available models.</div>
//                       </td>
//                     </tr>
//                   )}

//                   {vendorId && loading && (
//                     <tr>
//                       <td colSpan={3}>
//                         <div className="p-3 text-center text-muted">
//                           <span className="spinner-border spinner-border-sm me-2" />
//                           Loading available models…
//                         </div>
//                       </td>
//                     </tr>
//                   )}

//                   {vendorId && !loading && available.map(a => (
//                     <tr key={rowKey(a)}>
//                       <td>#{a.finalAssemblyId}</td>
//                       <td>
//                         <div className="fw-semibold">{a.componentPartNumber || "—"}</div>
//                         <div className="text-muted small text-truncate" style={{ maxWidth: 520 }}>
//                           {a.componentDescription || "—"}
//                         </div>
//                       </td>
//                       <td className="text-end">
//                         <button
//                           className="btn btn-sm btn-primary"
//                           onClick={() => assign(a.finalAssemblyId)}
//                           disabled={!canAct}
//                         >
//                           Add →
//                         </button>
//                       </td>
//                     </tr>
//                   ))}

//                   {vendorId && !loading && available.length === 0 && (
//                     <tr>
//                       <td colSpan={3}>
//                         <div className="p-3 text-center text-muted">
//                           No models available{leftQ ? " for this filter." : "."}
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* RIGHT: Assigned */}
//         <div style={panel}>
//           <div style={panelHeader}>
//             <strong>Mapped to vendor</strong>
//             <div style={headerTools}>
//               <input
//                 type="search"
//                 className="form-control form-control-sm"
//                 placeholder="Search…"
//                 value={rightQ}
//                 onChange={(e) => setRightQ(e.target.value)}
//                 style={{ width: 240 }}
//               />
//               <button className="btn btn-sm btn-light" onClick={() => setRightQ("")} disabled={!rightQ}>
//                 Clear
//               </button>
//             </div>
//           </div>

//           <div style={panelBody}>
//             <div className="table-responsive">
//               <table className="table table-hover table-sm mb-0">
//                 <thead className="table-light">
//                   <tr>
//                     <th style={{ width: 120 }}>Final ID</th>
//                     <th>Part # / Description</th>
//                     <th style={{ width: 160 }}>Approved On</th>
//                     <th style={{ width: 110 }} className="text-end">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {!vendorId && (
//                     <tr>
//                       <td colSpan={4}>
//                         <div className="p-3 text-center text-muted">Select a vendor above to view mapped models.</div>
//                       </td>
//                     </tr>
//                   )}

//                   {vendorId && loading && (
//                     <tr>
//                       <td colSpan={4}>
//                         <div className="p-3 text-center text-muted">
//                           <span className="spinner-border spinner-border-sm me-2" />
//                           Loading mapped models…
//                         </div>
//                       </td>
//                     </tr>
//                   )}

//                   {vendorId && !loading && assigned.map(a => (
//                     <tr key={rowKey(a)}>
//                       <td>#{a.finalAssemblyId}</td>
//                       <td>
//                         <div className="fw-semibold">{a.componentPartNumber || "—"}</div>
//                         <div className="text-muted small text-truncate" style={{ maxWidth: 420 }}>
//                           {a.componentDescription || "—"}
//                         </div>
//                       </td>
//                       <td>{a.approvedOn ? new Date(a.approvedOn).toLocaleString() : "—"}</td>
//                       <td className="text-end">
//                         <button
//                           className="btn btn-sm btn-outline-danger"
//                           onClick={() => deactivate(a.finalAssemblyId)}
//                           disabled={!canAct}
//                         >
//                           ← Remove
//                         </button>
//                       </td>
//                     </tr>
//                   ))}

//                   {vendorId && !loading && assigned.length === 0 && (
//                     <tr>
//                       <td colSpan={4}>
//                         <div className="p-3 text-center text-muted">
//                           No models mapped{rightQ ? " for this filter." : " yet."}
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }

// src/components/AuthoringComponent/VendorAssemblyMapPage.tsx
import React, { useEffect, useMemo, useState } from "react";
import { useVendorStore } from "../../store/vendorStore";
import { useVendorAssemblyStore } from "../../store/vendorAssemblyStore";
import { useUserStore } from "../../store/userStore";

function rowKey(a: { finalAssemblyId: number }) { return a.finalAssemblyId; }
function normRole(user: any): string {
  const raw = typeof user?.role === "string" ? user.role : user?.role?.roleName;
  return String(raw || "").trim().toUpperCase();
}

/* NOTE:
   Styling and structure changed only to use Bootstrap classes (container/row/col/cards/etc.)
   Logic, handlers and all data flows remain untouched.
*/

const pageWrap: React.CSSProperties = {
  padding: "16px 20px 24px",
};

const titleWrap: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 12,
};

const badge: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "6px 10px",
  borderRadius: 999,
  border: "1px solid #e5e5e5",
  background: "#f8f9fa",
  fontSize: 12,
};

export default function VendorAssemblyMapPage() {
  const { items: vendors, hasLoadedOnce: vLoaded, loading: vLoading, loadAll: loadVendors } = useVendorStore();
  const { vendorId, map, loading, error, setVendor, load, assign, deactivate } = useVendorAssemblyStore();

  const user = useUserStore((s) => s.user);
  const role = normRole(user);
  const userVendorId = Number(user?.vendorId ?? 0);

  const [leftQ, setLeftQ] = useState("");
  const [rightQ, setRightQ] = useState("");

  useEffect(() => { if (!vLoaded) void loadVendors(); }, [vLoaded, loadVendors]);

  // Optional auto-pick; selector stays visible regardless
  useEffect(() => {
    if (!vLoaded) return;
    if (!vendorId) {
      if (role === "VENDOR" && userVendorId > 0) setVendor(userVendorId);
      else if (vendors.length === 1) setVendor(vendors[0].vendorId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vLoaded, vendorId, vendors.length, role, userVendorId]);

  useEffect(() => { if (vendorId) void load(vendorId); }, [vendorId, load]);

  const selectedVendor = useMemo(() => vendors.find(v => v.vendorId === vendorId), [vendors, vendorId]);

  const available = useMemo(() => {
    const arr = map?.available ?? [];
    const term = leftQ.trim().toLowerCase();
    if (!term) return arr;
    return arr.filter(a =>
      (a.componentPartNumber || "").toLowerCase().includes(term) ||
      (a.componentDescription || "").toLowerCase().includes(term)
    );
  }, [map, leftQ]);

  const assigned = useMemo(() => {
    const arr = map?.assigned ?? [];
    const term = rightQ.trim().toLowerCase();
    if (!term) return arr;
    return arr.filter(a =>
      (a.componentPartNumber || "").toLowerCase().includes(term) ||
      (a.componentDescription || "").toLowerCase().includes(term)
    );
  }, [map, rightQ]);

  const canAct = Boolean(vendorId) && !loading;

  return (
    <div style={pageWrap} className="container-fluid">
      {/* Always-visible selector row */}
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3 pb-2 border-bottom">
        <div style={titleWrap} className="mb-2 mb-md-0">
          <h5 style={{ margin: 0 }}>Vendor ↔ Models Mapping</h5>
          <span style={badge}>
            <span>Selected vendor:</span>
            <strong>{selectedVendor?.vendorName ?? "—"}</strong>
            {vendorId ? <span style={{ color: "#888" }}>#{vendorId}</span> : null}
          </span>
        </div>

        <div className="d-flex align-items-center gap-2">
          <select
            className="form-select form-select-sm"
            style={{ minWidth: 260 }}
            value={vendorId ?? ""}
            onChange={(e) => setVendor(e.target.value ? Number(e.target.value) : null)}
            disabled={vLoading}
          >
            <option value="">Select Vendor…</option>
            {vendors.map(v => (
              <option key={v.vendorId} value={v.vendorId}>{v.vendorName}</option>
            ))}
          </select>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => vendorId && load(vendorId)}
            disabled={!vendorId || loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Loading…
              </>
            ) : (
              "Refresh"
            )}
          </button>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {/* Two panels — bootstrap responsive columns */}
      <div className="row g-3">
        {/* LEFT: Available */}
        <div className="col-12 col-lg-6">
          <div className="card h-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <strong className="mb-0">Available models</strong>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search…"
                  value={leftQ}
                  onChange={(e) => setLeftQ(e.target.value)}
                  style={{ width: 240 }}
                />
                <button className="btn btn-sm btn-light" onClick={() => setLeftQ("")} disabled={!leftQ}>
                  Clear
                </button>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover table-sm mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 120 }}>Final ID</th>
                      <th>Part # / Description</th>
                      <th style={{ width: 90 }}>Ver</th>
                      <th style={{ width: 110 }} className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!vendorId && (
                      <tr>
                        <td colSpan={4}>
                          <div className="p-3 text-center text-muted">Select a vendor above to view available models.</div>
                        </td>
                      </tr>
                    )}

                    {vendorId && loading && (
                      <tr>
                        <td colSpan={4}>
                          <div className="p-3 text-center text-muted">
                            <span className="spinner-border spinner-border-sm me-2" />
                            Loading available models…
                          </div>
                        </td>
                      </tr>
                    )}

                    {vendorId && !loading && available.map(a => (
                      <tr key={rowKey(a)}>
                        <td>#{a.finalAssemblyId}</td>
                        <td>
                          <div className="fw-semibold">{a.componentPartNumber || "—"}</div>
                          <div className="text-muted small text-truncate" style={{ maxWidth: 520 }}>
                            {a.componentDescription || "—"}
                          </div>
                        </td>
                        <td>{a.currentVersionId ?? "-"}</td>
                        <td className="text-end">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => assign(a.finalAssemblyId)}
                            disabled={!canAct}
                          >
                            Add →
                          </button>
                        </td>
                      </tr>
                    ))}

                    {vendorId && !loading && available.length === 0 && (
                      <tr>
                        <td colSpan={4}>
                          <div className="p-3 text-center text-muted">
                            No models available{leftQ ? " for this filter." : "."}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: Assigned */}
        <div className="col-12 col-lg-6">
          <div className="card h-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <strong className="mb-0">Mapped to vendor</strong>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search…"
                  value={rightQ}
                  onChange={(e) => setRightQ(e.target.value)}
                  style={{ width: 240 }}
                />
                <button className="btn btn-sm btn-light" onClick={() => setRightQ("")} disabled={!rightQ}>
                  Clear
                </button>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover table-sm mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 120 }}>Final ID</th>
                      <th>Part # / Description</th>
                      <th style={{ width: 90 }}>Ver</th>
                      <th style={{ width: 160 }}>Approved On</th>
                      <th style={{ width: 110 }} className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!vendorId && (
                      <tr>
                        <td colSpan={5}>
                          <div className="p-3 text-center text-muted">Select a vendor above to view mapped models.</div>
                        </td>
                      </tr>
                    )}

                    {vendorId && loading && (
                      <tr>
                        <td colSpan={5}>
                          <div className="p-3 text-center text-muted">
                            <span className="spinner-border spinner-border-sm me-2" />
                            Loading mapped models…
                          </div>
                        </td>
                      </tr>
                    )}

                    {vendorId && !loading && assigned.map(a => (
                      <tr key={rowKey(a)}>
                        <td>#{a.finalAssemblyId}</td>
                        <td>
                          <div className="fw-semibold">{a.componentPartNumber || "—"}</div>
                          <div className="text-muted small text-truncate" style={{ maxWidth: 420 }}>
                            {a.componentDescription || "—"}
                          </div>
                        </td>
                        <td>{a.currentVersionId ?? "-"}</td>
                        <td>{a.approvedOn ? new Date(a.approvedOn).toLocaleString() : "—"}</td>
                        <td className="text-end">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deactivate(a.finalAssemblyId)}
                            disabled={!canAct}
                          >
                            ← Remove
                          </button>
                        </td>
                      </tr>
                    ))}

                    {vendorId && !loading && assigned.length === 0 && (
                      <tr>
                        <td colSpan={5}>
                          <div className="p-3 text-center text-muted">
                            No models mapped{rightQ ? " for this filter." : " yet."}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
